import styled from "styled-components";
import ApiException from "../../types/ApiException";

const StyledLabel = styled.label`
  margin-top: -3px !important;
  input {
    margin-bottom: 0.5rem;
  }
`;

interface RadioItemProps {
  label: string;
  children: React.ReactNode;          // one or more <RadioInput/>
  required?: boolean;
  err?: ApiException | null;
  errField: string;
}

const RadioItem = ({ label, children, required, err, errField }: RadioItemProps) => (
  <>
    <StyledLabel>
      {required ? (
        <span className="bold">
          {label}:<span className="red">*</span>
        </span>
      ) : (
        `${label}:`
      )}
    </StyledLabel>

    <div>{children}</div>

    {err?.ValidationErrors?.[errField] && (
      <span className="error red">{err.ValidationErrors[errField]}</span>
    )}
  </>
);

export default RadioItem;
